import camelcase from 'camelcase';
import { formatDate } from 'src/common/utils/dateHelpers';
import { BookingMotivatorsState } from 'src/common/providers/useBookingMotivators';
import IconDS22 from 'src/common/components/IconDS22';
import styles from './DayContent.module.scss';

type Props = {
  day: number;
  date?: Date;
  showInstabook?: boolean;
  bookingMotivators?: BookingMotivatorsState;
};

const DayContent: React.FC<Props> = ({
  showInstabook,
  bookingMotivators,
  date,
  day,
}) => {
  const motivators = date && bookingMotivators?.[formatDate(date)]
    ? bookingMotivators[formatDate(date)]
    : [];

  return (
    <>
      {showInstabook && (
        <IconDS22
          id="instabook-filled"
          size="xs"
          className={styles.icon}
        />
      )}
      {day}
      {motivators.length > 0 && (
        <div className={styles.dayMotivators}>
          {motivators.map((motivator) => (
            <div key={motivator} className={styles[camelcase(motivator)]} />
          ))}
        </div>
      )}
    </>
  );
};

export default DayContent;
